import styled from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { TextLink } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { abbrNumberFilter } from "app/filters/ngFilters";

import { formatDateRange } from "./verification-widget.utils";

const formatAbbr = abbrNumberFilter();

const ClickableTextLink = styled(TextLink)`
    cursor: pointer;
`;

interface IVerificationTooltipProps {
    publisher: string;
    dateFrom: string;
    dateTo: string;
    screenshots: number;
    timesSeen: number;
    onlyScreenshots: boolean;
    onDetailsClick: () => void;
}

export const VerificationTooltip = ({
    publisher,
    dateFrom,
    dateTo,
    screenshots,
    timesSeen,
    onlyScreenshots,
    onDetailsClick,
}: IVerificationTooltipProps) => {
    const { translate } = useTranslate();

    const visitsLine = translate("ad.intelligence.verification.tooltip.summary_visits", {
        captures: formatAbbr(timesSeen),
    });
    const screenshotsLine = translate("ad.intelligence.verification.tooltip.summary_screenshots_only", {
        screenshots: formatAbbr(screenshots),
    });

    return (
        <Stack gap="8px">
            <Text
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[500]}
            >
                {publisher}
            </Text>
            <Stack gap="2px">
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[500]}
                >
                    {formatDateRange(dateFrom, dateTo)}
                </Text>
                {!onlyScreenshots ? (
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon[500]}
                    >
                        {visitsLine}
                    </Text>
                ) : null}
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[500]}
                >
                    {screenshotsLine}
                </Text>
            </Stack>
            <ClickableTextLink
                translations={{ opensInNewTab: "" }}
                onClick={onDetailsClick}
            >
                {translate("ad.intelligence.verification.tooltip.cta")}
            </ClickableTextLink>
        </Stack>
    );
};
